import { createEffect, onCleanup, Show } from "solid-js";
import { createDroppable } from "@thisbeyond/solid-dnd";
import { useTranslation } from "../../../state/i18n";
import EmptyState from "../../../components/emptyState/EmptyState";
import type { FormScope } from "../../../state/formVersion";
import { Scope } from "../../../types";

type EmptyDropZoneProps = {
  currentScope: FormScope;
};

const EmptyDropZone = (props: EmptyDropZoneProps) => {
  const { t } = useTranslation();
  const droppable = createDroppable("empty");
  let ref!: HTMLDivElement;

  // Change background color of main editor element when dropzone is active
  createEffect(() => {
    const contentElement = ref.closest("main");

    if (droppable.isActiveDroppable) {
      contentElement?.classList.add(`bg-surface-hover!`);
    } else {
      contentElement?.classList.remove(`bg-surface-hover!`);
    }
  });

  onCleanup(() => {
    ref.closest("main")?.classList.remove(`bg-surface-hover!`);
  });

  return (
    <div use:droppable ref={ref}>
      <Show when={props.currentScope !== Scope.ROOT}>
        <EmptyState
          illustration={{ primaryIcon: "dragAndDrop" }}
          title={t(($) => $.FIELDS_EMPTY_STATE_TITLE)}
          description={t(($) => $.FIELDS_EMPTY_STATE_DESCRIPTION)}
        />
      </Show>
    </div>
  );
};

export default EmptyDropZone;
